import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class CustomStatusServices {

  createCustomStatus = async (payload) => {
    const CustomStatus = await Helpers.post({
      url: Constants.CREATE_CUSTOM_STATUS,
      data: payload,
    });
    return CustomStatus;
  }

  updateCustomStatus = async (payload) => {
    const CustomStatus = await Helpers.put({
      url: Constants.UPDATE_CUSTOM_STATUS,
      data: payload,
    });
    return CustomStatus;
  }

  getCustomStatus = async (orgId, entityName) => {
    let url = `${Constants.GET_CUSTOM_STATUS}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (entityName) url += `entity_name=${entityName}&`;
    const CustomStatus = await Helpers.get({ url });
    return CustomStatus;
  }

  getOrgStatus = async (orgId, entityName, orderType) => {
    let url = `${Constants.GET_ORG_STATUS}/${entityName.toLowerCase()}/edit_page?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (orderType) url += `order_type=${orderType}&`
    const orgStatus = await Helpers.get({ url });
    return orgStatus;
  }

  deleteCustomStatus = async (payload) => {
    const deleteCustomStatus = await Helpers.delete({
      url: Constants.DELETE_CUSTOM_STATUS,
      data: payload,
    });
    return deleteCustomStatus;
  }
}
export default new CustomStatusServices();
